import actions from '../../actionTypes';

export default (email, token) => {
  return {
    type: actions.VERIFY_PASSWORD_TOKEN,
    email,
    token
  };
};



// WEBPACK FOOTER //
// ./src/reducers/auth/actions/verifyPasswordToken.js